const Menu = [
    { header: 'Promet Bohinj' },

    {
        name: 'dashboard',
        title: 'Pregled',
        icon: 'mdi-view-dashboard',
        path: '/pregled',
        group: 'dashboard',
        permissions: [],
        top_level: true
    }
        
]

export { Menu }